export default __webpack_public_path__ + "static/media/icn-trucking-time.c9b8efa5.svg";